import React from 'react';
import styled from 'styled-components/macro';
import { Button, Title } from '@cognite/cogs.js';
import { Icon } from 'components/Icon';
import { Modal } from 'antd';

export const ConfirmationDialog = ({
  title,
  message,
  loading = false,
  textOk = 'Ok',
  textCancel = 'Cancel',
  width = 500,
  onOk,
  onClose,
  buttonTypeOk = 'primary',
  closable = true,
}: {
  title?: string;
  message?: string | React.ReactNode;
  loading?: boolean;
  width?: number;
  textOk?: string;
  textCancel?: string;
  onOk: () => void;
  onClose: () => void;
  buttonTypeOk?: 'primary' | 'secondary' | 'ghost' | 'destructive';
  closable?: boolean;
}) => (
  <Modal
    visible
    closeIcon={<Icon type="Close" onClick={onClose} />}
    footer={null}
    onCancel={onClose}
    maskClosable
    width={width}
    closable={closable}
  >
    {title && (
      <Title level={4} style={{ marginBottom: '1.5rem' }}>
        {title}
      </Title>
    )}
    {message}
    <StyledButtons hasMessage={!!message}>
      <Button
        size="small"
        type="ghost"
        onClick={onClose}
        style={{ marginRight: '1rem' }}
      >
        {textCancel}
      </Button>
      <Button size="small" type={buttonTypeOk} loading={loading} onClick={onOk}>
        {textOk}
      </Button>
    </StyledButtons>
  </Modal>
);

interface IStyledButtonsType {
  hasMessage: boolean;
}

const StyledButtons = styled.div<IStyledButtonsType>`
  padding: ${(props: IStyledButtonsType) =>
    props.hasMessage ? '2rem 0 0 0' : '0'};
  text-align: right;
`;
